import React from "react";
import "./RowPlaceholder.scss";
var RowPlaceholder = function () {
    return (React.createElement("div", { className: "rowPlaceholderContainer" }));
};
export default RowPlaceholder;
